import { Typography } from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <div >
            <Typography sx={{ fontWeight: 600, mt: 10 }} variant="h4" component="div" className="text-warning">
                Payment Is Coming Soon:
            </Typography>
        </div>
    );
};

export default Payment;